/* eslint-disable react/require-default-props */
/*
 *
 * LanguageProvider
 *
 * this component connects the redux state language locale to the
 * IntlProvider component and i18n messages (loaded from `app/translations`)
 */

import { Settings } from 'luxon';
import PropTypes from 'prop-types';
import React from 'react';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { makeSelectLocale } from './selectors';

function loadLocaleData(locale) {
  switch (locale) {
    case 'en':
      return import('../../translations/en.json');
    default:
      return import('../../translations/ro.json');
  }
}
export function LanguageProvider(props) {
  const [messages, setMessages] = React.useState(null); // Initially null
  const [loading, setLoading] = React.useState(true); // Loading state

  React.useEffect(() => {
    Settings.defaultLocale = props.locale;
    Settings.defaultZone = 'UTC';
    // Load translations
    const fetchMessages = async () => {
      setLoading(true);
      const loadedData = await loadLocaleData(props.locale);
      setMessages(loadedData.default);
      setLoading(false);
    };
    fetchMessages();
  }, [props.locale]);

  if (loading || !messages) {
    return <div>Loading translations...</div>; // Avoid rendering IntlProvider with empty messages
  }

  return (
    <IntlProvider locale={props.locale || 'ro'} messages={messages}>
      {React.Children.only(props.children)}
    </IntlProvider>
  );
}

LanguageProvider.propTypes = {
  locale: PropTypes.string,
  children: PropTypes.element.isRequired,
};

const mapStateToProps = createSelector(makeSelectLocale(), (locale) => ({
  locale,
}));

export default connect(mapStateToProps)(LanguageProvider);
